module.exports = __webpack_public_path__ + "img/32.05df7cc4.jpg";